var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('Loader'):_c('div',{staticClass:"header"},[_c('InformationsMarche'),_c('BannierePub',{attrs:{"items":_vm.itemsBanniere}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }